export enum FormatValues {
  BOLD = 'BOLD',
  ITALIC = 'ITALIC',
  UNDERLINE = 'UNDERLINE',
  STRIKETHROUGH = 'STRIKETHROUGH'
}

export enum AlignmentValues {
  LEFT = 'left',
  RIGHT = 'right',
  CENTER = 'center'
}

export enum BlockTypeValues {
  H1 = 'header-one',
  H2 = 'header-two',
  H3 = 'header-three',
  H4 = 'header-four',
  H5 = 'header-five',
  H6 = 'header-six',
  BLOCKQUOTE = 'blockquote',
  CODE_BLOCK = 'code-block',
  ATOMIC = 'atomic',
  UNORDERED_LIST_ITEM = 'unordered-list-item',
  ORDERED_LIST_ITEM = 'ordered-list-item',
  UNSTYLED = 'unstyled'
}
